import { AppletEmptyStateType } from '../applet-empty-state-type';
import { StatusCodes } from 'http-status-codes';

export function statusCodeToEmptyStateAdapter(statusCode) {
    switch(statusCode) {
        case StatusCodes.NOT_FOUND:
            return AppletEmptyStateType.NO_SEARCH;
        case StatusCodes.CONFLICT:
            return AppletEmptyStateType.INCOMPATIBLE;
        case StatusCodes.GATEWAY_TIMEOUT:
            return AppletEmptyStateType.SEARCH_TIMEOUT;
        case StatusCodes.PAYMENT_REQUIRED:
            return AppletEmptyStateType.PAYMENT_REQUIRED;
        case StatusCodes.REQUEST_TOO_LONG:
            return AppletEmptyStateType.QUERY_TOO_COMPLEX;
        case StatusCodes.INSUFFICIENT_SPACE_ON_RESOURCE:
            return AppletEmptyStateType.TOO_MANY_INPUTS;
        case StatusCodes.BAD_REQUEST:
        default:
            return AppletEmptyStateType.NO_DATA;
    }
}